import { api } from '../api';
import type { Role, PermissionGroup, CreateRoleInput, UpdateRoleInput, RoleScopeAssignment, UserRoleDetail } from '@/types/user';

export const orgRoleApi = {
  getAll: () => api.get<Role[]>('/org/roles'),
  getPermissions: () => api.get<PermissionGroup[]>('/org/roles/permissions'),
  getScopes: () => api.get<RoleScopeAssignment[]>('/org/roles/scopes'),
  getById: (id: string) => api.get<Role>(`/org/roles/${id}`),
  getUserAssignments: (id: string) => api.get<UserRoleDetail[]>(`/org/roles/${id}/users`),
  create: (data: CreateRoleInput) => api.post<Role>('/org/roles', data),
  update: (id: string, data: UpdateRoleInput) => api.patch<Role>(`/org/roles/${id}`, data),
  delete: (id: string) => api.delete<void>(`/org/roles/${id}`),
  getUsers: (id: string) => api.get<Array<{ id: string }>>(`/org/roles/${id}/users`),
};

export const roleApi = {
  getAll: (params?: { organizationId?: number }) => {
    const qs = new URLSearchParams();
    if (params?.organizationId !== undefined) qs.set('organizationId', String(params.organizationId));
    const query = qs.toString();
    return api.get<Role[]>(`/roles${query ? `?${query}` : ''}`);
  },
  getById: (id: string) => api.get<Role>(`/roles/${id}`),
  getSystemRoles: () => api.get<Role[]>('/roles/system'),
  getPermissions: () => api.get<PermissionGroup[]>('/roles/permissions'),
  getUsers: (id: string) => api.get<Array<{ id: string }>>(`/roles/${id}/users`),
  getScopes: () => api.get<RoleScopeAssignment[]>('/roles/scopes'),
  getUserAssignments: (id: string) => api.get<UserRoleDetail[]>(`/roles/${id}/users`),
  create: (data: CreateRoleInput) => api.post<Role>('/roles', data),
  update: (id: string, data: UpdateRoleInput) => api.patch<Role>(`/roles/${id}`, data),
  delete: (id: string) => api.delete<void>(`/roles/${id}`),
};
